import script from "./BoilerItem.vue?vue&type=script&setup=true&lang=js"
export * from "./BoilerItem.vue?vue&type=script&setup=true&lang=js"

import "./BoilerItem.vue?vue&type=style&index=0&id=056558b3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-056558b3"]])

export default __exports__